/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UserControllerCreateMutationResponse, UserControllerCreate400, UserControllerCreate401 } from "../../models/usersController/UserControllerCreate";

function getUserControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/users` as const }  
  return res
}

/**
 * @summary Create a new user
 * {@link /api/v1/users}
 */
export async function userControllerCreate(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UserControllerCreateMutationResponse, ResponseErrorConfig<UserControllerCreate400 | UserControllerCreate401>, unknown>({ method : "POST", url : getUserControllerCreateUrl().url.toString(), ... requestConfig })  
  return res.data
}